import axios from "axios";

const awsGTWAxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_AWS_API,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

export default awsGTWAxiosInstance;
